export default {
      id: "color_profile-usage",
      viewBox: "0 0 74 99",
      url: __webpack_public_path__ + "sprite.svg#color_profile",
      toString: function () {
        return this.url;
      }
    }